// pages/trucker/TruckerConfirm.js
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import notificationApi from '../../services/notificationApi'
import { useGlobal } from '../../context/GlobalContext'

function TruckerConfirm() {
  const [searchParams] = useSearchParams()
  const [message, setMessage] = useState('')
  const [confirmed, setConfirmed] = useState(false)
  const [lat, setLat] = useState(null)
  const [lng, setLng] = useState(null)
  const phone = searchParams.get('phone') || ''
  const jobId = searchParams.get('jobId') || ''
  const stepId = searchParams.get('stepId') || ''
  const { showLoading, hideLoading, showMessage } = useGlobal()

  useEffect(() => {
    let canceled = false
    console.log('[TruckerConfirm] requesting geolocation')
    showLoading()
    navigator.geolocation.getCurrentPosition(
      pos => {
        if (!canceled) {
          console.log('[TruckerConfirm] geolocation success:', pos.coords)
          setLat(pos.coords.latitude)
          setLng(pos.coords.longitude)
          hideLoading()
        }
      },
      error => {
        if (!canceled) {
          console.log('[TruckerConfirm] geolocation error:', error)
          hideLoading()
          showMessage('Could not get location', 'error')
        }
      }
    )
    return () => {
      canceled = true
    }
  }, [])

  const handleConfirm = async () => {
    console.log('[TruckerConfirm] handleConfirm clicked')
    if (!phone || !jobId || !stepId) {
      console.log('[TruckerConfirm] invalid parameters')
      setMessage('Invalid parameters')
      return
    }
    try {
      showLoading()
      const payload = { phone, jobId, stepId, lat, lng }
      console.log('[TruckerConfirm] sending payload:', payload)
      const res = await notificationApi.post('/confirmation/confirm-step', payload)
      console.log('[TruckerConfirm] confirmation response:', res.data)
      setMessage(res.data.message)
      setConfirmed(true)
      hideLoading()
      showMessage('Step confirmed successfully', 'success')
    } catch (err) {
      console.log('[TruckerConfirm] confirmation error:', err.response?.data)
      hideLoading()
      showMessage(err.response?.data?.error || 'Error confirming', 'error')
    }
  }

  if (!phone || !jobId) {
    return (
      <div>
        <h2>Invalid Link</h2>
        <p>Phone or JobId missing.</p>
      </div>
    )
  }

  return (
    <div>
      {!confirmed && (
        <>
          <h2>Trucker Confirmation</h2>
          <p>Job: {jobId}</p>
          <p>Step: {stepId}</p>
          <p>Phone: {phone}</p>
          <p>Location: {lat && lng ? `${lat}, ${lng}` : 'Detecting...'}</p>
          <button onClick={handleConfirm} disabled={!lat || !lng}>
            Confirm
          </button>
          {message && <p>{message}</p>}
        </>
      )}
      {confirmed && (
        <>
          <h2>Confirmed</h2>
          <p>{message}</p>
        </>
      )}
    </div>
  )
}

export default TruckerConfirm